
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 96 96","xmlns":"http://www.w3.org/2000/svg","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"28.25","y":"10.25","width":"39.5","height":"75.5","rx":"6.75","fill":"currentColor","fill-opacity":".07","stroke":"currentColor","stroke-width":"2.5"}}),_c('rect',{attrs:{"x":"36","y":"20","width":"24","height":"5","rx":"2.5","fill":"currentColor","fill-opacity":".45"}}),_c('circle',{attrs:{"cx":"40","cy":"36","r":"4","fill":"currentColor","fill-opacity":".45"}}),_c('path',{attrs:{"d":"M36 50h24m-24 8h24m-24 8h16","stroke":"currentColor","stroke-width":"2.5","stroke-linecap":"round","opacity":".28"}})])
          )
        }
      }
    